<template>
  <el-dialog
    :visible.sync="visible"
    width="600px"
    :before-close="handleClose"
    custom-class="upload-invoice-dialog"
  >
    <template slot="title">
      <div class="dialog-title">
        <img src="@/assets/images/upload-icon2.png" style="color: #1990FF; width: 20px; height: 20px; margin-right: 6px;" />
        <span>上传发票</span>
      </div>
    </template>

    <!-- 报表信息 -->
    <div class="report-info">
      <div class="info-row">
        <span class="info-label">报表名</span>
        <span class="info-value">{{ row.fileName || '--' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">结算佣金金额</span>
        <span class="info-value red">¥{{ row.settlementAmount || 0 }}</span>
      </div>
    </div>

    <!-- 已上传发票 -->
    <div class="section-title">已上传发票</div>
    <div class="uploaded-list" v-if="invoiceList.length">
      <div class="invoice-item" v-for="(item, index) in invoiceList" :key="index">
        <div class="invoice-icon">
          <img v-if="isPdf(item.fileName)" src="@/assets/images/pdf.png" class="file-icon" />
          <img v-else src="@/assets/images/file.png" class="file-icon" />
        </div>
        <div class="invoice-info">
          <div class="invoice-name">{{ item.fileName || '发票文件' }}</div>
          <div class="invoice-meta">
            <!-- {{ item.uploadTime || '' }} -->
            {{ item.fileSize ? ' | ' + item.fileSize : '' }}</div>
        </div>
        <div class="invoice-actions">
          <el-button type="text" @click="handleDownloadInvoice(item)">下载</el-button>
          <el-button type="text" style="color: #F56C6C !important;" @click="handleDeleteInvoice(item, index)">删除</el-button>
        </div>
      </div>
    </div>
    <div class="empty-invoice" v-else>
      <img src="@/assets/images/default.png" class="empty-icon" />
      <div class="empty-text">暂无发票</div>
      <div class="empty-desc">请在下方上传对应的发票文件</div>
    </div>

    <!-- 上传新发票 -->
    <div class="section-title" style="margin-top: 16px;">上传新发票</div>
    <div class="upload-area">
      <UiUpload
        tip="点击上传发票文件"
        fileType="imagePdf"
        @submit="handleFileSubmit"
      >
      </UiUpload>
      <div class="tip">支持PDF、JPG、PNG格式</div>
    </div>

    <!-- 开票信息 -->
    <div class="billing-section">
      <div class="billing-header">
        <span class="billing-title">开票信息：</span>
        <el-button type="text" v-if="billingInfo" icon="el-icon-document-copy" @click="handleCopyAll">一键复制</el-button>
      </div>
      <div class="billing-content" style="white-space: pre-wrap;">{{ billingInfo }}</div>
    </div>

    <template slot="footer">
      <el-button @click="handleClose">关 闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import UiUpload from '@/page/component/ui/ui-upload.vue'
import { uploadImage } from '@/service/apis/common'
// import moment from 'moment'
const DEFAULT_INFO = `· 开票类目：*信息系统服务*信息系统服务
· 开票主体：合肥利维坦科技有限公司
· 统一社会信用代码：91340104MAD9TR844X
· 公司地址：安徽省合肥市蜀山区望江西路华府骏苑13栋305室`

export default {
  name: 'UploadInvoiceDialog',
  components: { UiUpload },
  props: {
    value: { type: Boolean, default: false },
    row: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      invoiceList: [],
      billingInfo: DEFAULT_INFO
    }
  },
  computed: {
    visible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.getInvoiceConfig()
          this.getInvoiceList()
        }
      },
      immediate: true
    }
  },
  methods: {
    formatfileSize(bytes) {
      if (!bytes || bytes === 0) return '0B'
      const units = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(1024))
      return (bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 2) + units[i]
    },
    isPdf(name) {
      return name && /\.pdf$/i.test(name)
    },
    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    },

    getInvoiceList() {
      this.$http('get', 'mall/bdM2sSettlementAttachment/invoiceList', { reportId: this.row.id }).then(res => {
        this.invoiceList = res || []
      }).catch((e) => {
        console.error(e)
      })
    },
    getInvoiceConfig() {
      this.$http('get', 'mall/bdM2sSettlementInvoiceConfig/getInvoiceConfig', {}).then(res => {
        this.billingInfo = res|| ''
        console.log('billingInfo:', res)
      }).catch(() => {})
    },
    handleFileSubmit(file) {
      const allowExts = /\.(pdf|jpe?g|png)$/i
      if (!allowExts.test(file.name)) {
        this.$message.warning('仅支持PDF、JPG、PNG格式的文件')
        return
      }
      const formData = new FormData()
      formData.append('media', file)
      
      // 先上传文件拿到url
      uploadImage.call(this, formData).then(resp => {
        const filePath = resp.img || resp
        // 再关联到结算记录
        return this.$http('post', 'mall/bdM2sSettlementAttachment/uploadInvoice', {
          reportId: this.row.id,
          filePath,
          fileName: file.name
        })
      }).then(() => {
        this.$message.success('上传成功')
        this.getInvoiceList()
      }).catch(() => {})
    },
    handleDownloadInvoice(item) {
      if (item.filePath) {
        window.open(item.filePath, '_blank')
      }
    },
    handleDeleteInvoice(item, index) {
      this.$confirm('确定删除该发票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http('post', 'mall/bdM2sSettlementAttachment/deleteInvoice?attachmentId=' + item.id).then(() => {
          this.$message.success('删除成功')
          this.invoiceList.splice(index, 1)
          this.$emit('on-success')
        })
      }).catch(() => {})
    },
    handleCopyAll() {
      const text = this.billingInfo || ''
      const input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    }
  }
}
</script>

<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.report-info {
  border: 1px solid #e8ecf2;
  border-radius: 6px;
  padding: 14px 20px;
  margin-bottom: 16px;
}
.info-row {
  display: flex;
  line-height: 30px;
}
.info-label {
  width: 100px;
  flex-shrink: 0;
  color: #999;
  font-size: 14px;
}
.info-value {
  color: #333;
  font-size: 14px;
  flex: 1;
}
.info-value.red {
  color: rgba(232, 0, 0, 1);
  font-weight: 600;
}
.section-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-bottom: 10px;
}
/* 已上传发票列表 */
.invoice-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid #e8ecf2;
  border-radius: 6px;
  margin-bottom: 8px;
}
.file-icon {
  width: 16px;
  height: 16px;
}
.invoice-info {
  flex: 1;
  margin-left: 10px;
}
.invoice-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.invoice-meta {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}
.invoice-actions {
  flex-shrink: 0;
}
/* 空状态 */
.empty-invoice {
  text-align: center;
  padding: 24px 0;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  margin-bottom: 16px;
}
.empty-icon {
  width: 48px;
  height: 48px;
  opacity: 0.5;
}
.empty-text {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-top: 8px;
}
.empty-desc {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
/* 上传区域 */
.upload-area {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  transition: border-color 0.2s;
}
.upload-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.upload-text {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-top: 8px;
}
.upload-hint {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
/* 开票信息 */
.billing-section {
  margin-bottom: 8px;
}
.billing-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}
.billing-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
.billing-content {
  font-size: 13px;
  color: #666;
  line-height: 24px;
}
.tip {
  font-size: 12px;
  padding-top: 6px;
  color: #888;
}
</style>
